// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__CWq7_","filesListContainer":"PosDisputesFiles_filesListContainer__2-jS2","filesButton":"PosDisputesFiles_filesButton__3DR7T"};